import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.directory-integration.manage.domains', {
        url: '/domains',
        component: 'companyDirectoryIntegrationManageDomainsConfiguration',
        resolve: {
            domains,
        },
    });
}

/** @ngInject */
function domains($filter, companyId, directory, DirectoriesResource) {
    return DirectoriesResource.getDomains(companyId, directory.id, directory.type)
        .then((domains) => $filter('orderBy')(domains, 'isRootDomain', true))
}



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/manage/domains/directory-manage-domains.state.js